<div *ngIf="!!banners?.length" [class.pb-4]="!isOnlyOneBanner">
  <div class="carousel-holder">
    <ngb-carousel
      #carousel
      [showNavigationArrows]="false"
      [showNavigationIndicators]="false"
      [pauseOnHover]="false"
      [pauseOnFocus]="false"
      [interval]="duration"
      [wrap]="true"
      (slide)="onSlide($event)"
    >
      <ng-template ngbSlide *ngFor="let banner of banners; let i = index" [id]="'slide-' + i">
        <div class="banner-collection-holder">
          <ng-container
            [styleClassesOverride]="styleClasses"
            [cxComponentWrapper]="{
              flexType: 'BannerComponent',
              typeCode: 'BannerComponent',
              uid: banner.uid,
            }"
          ></ng-container>
        </div>
      </ng-template>
    </ngb-carousel>

    <div *ngIf="!isOnlyOneBanner" class="controls-holder d-flex justify-content-between px-2">
      <button
        class="btn-icon"
        (click)="goToSlide('prev')"
        [ngbTooltip]="'timedBannerCollection.previous_action' | cxTranslate"
        [attr.aria-label]="'common.previous_action' | cxTranslate"
      >
        <i nz-icon nzType="left-circle"></i>
      </button>
      <button
        class="btn-icon"
        (click)="togglePauseAndPlay()"
        [ngbTooltip]="(paused ? 'timedBannerCollection.play_action' : 'timedBannerCollection.pause_action') | cxTranslate"
        [attr.aria-label]="'common.pause_action' | cxTranslate"
      >
        <i nz-icon [nzType]="paused ? 'play-circle' : 'pause-circle'"></i>
      </button>
      <button
        class="btn-icon"
        (click)="goToSlide('next')"
        [ngbTooltip]="'timedBannerCollection.next_action' | cxTranslate"
        [attr.aria-label]="'common.next_action' | cxTranslate"
      >
        <i nz-icon nzType="right-circle"></i>
      </button>
    </div>
  </div>

  <div *ngIf="!isOnlyOneBanner" class="container indicators-wrapper">
    <div class="row no-gutters d-flex flex-wrap justify-content-center">
      <div
        class="dot-holder d-flex flex-column px-2 px-md-4 mt-4"
        *ngFor="let banner of banners; let i = index"
        (click)="goToSlide(i)"
      >
        <py-progressbar
          class="mt-2"
          [index]="i"
          [activeSlideId]="activeSlide"
          [duration]="duration"
          [paused]="paused"
          (timeLeft)="timeLeft = $event"
        ></py-progressbar>

        <div class="d-none d-lg-block p-4 text-center dot-text">
          {{ banner.headline | stripHtml }}
        </div>
      </div>
    </div>
  </div>
</div>
